import * as queryString from "query-string";

export const setLocation = (path, queryParams) => {
    window.history.replaceState(undefined, undefined, `${path}${queryParams && '?' + queryString.stringify(queryParams)}`);
};